import { Box, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Lista } from "./Lista";
import { Header } from "../../components/Header";

export function Faturas(){
  const form = useForm()

  return (
    <FormProvider {...form}>
      <Box
        display={"flex"}
        flexDir={"column"}
        justifyContent={"center"}
        width={"full"}
        alignItems={"center"}
      >
        <Flex
          maxWidth={"90%"}
          width={"100%"}
          flexDir={"column"}
          justifyContent={"center"}
        >
          <Header />
          <Box
            px={"1rem"}
            bg={"white"}
            w={"full"}
            display={"flex"}
            flexDir={"column"}
            gap={"8"}
            pb={8}
          >
            <Lista />
          </Box>
        </Flex>
      </Box>
    </FormProvider>
  );
}